export enum StorageInboundLotInformationAction {
  SET_STORAGE_INBOUND_LOT_INFORMATION = "SET_STORAGE_INBOUND_LOT_INFORMATION",
}
